import { useState, useEffect } from 'react';

const FILTER_TOPIC = 'ws-locations-data/filter-visibility';

/**
 * Hook to listen for filter visibility changes published by
 * ws-locations-control's FilterToggleButton through DDC pubsub
 * (via ws-locations-data bus).
 *
 * @returns {boolean} Whether filters should be visible
 */
export const useShowFilterEvent = () => {
	const [showFilter, setShowFilter] = useState(false);

	useEffect(() => {
		if (typeof window === 'undefined') {
			return () => {};
		}

		// Subscribe to DDC pubsub topic for filter visibility
		const handleFilterChange = (data) => {
			if (data && typeof data.visible === 'boolean') {
				setShowFilter(data.visible);
			}
		};

		const pubsub = window.DDC?.pubsub;
		if (pubsub) {
			pubsub.subscribe(FILTER_TOPIC, handleFilterChange);
		}

		return () => {
			if (pubsub) {
				pubsub.unsubscribe(FILTER_TOPIC, handleFilterChange);
			}
		};
	}, []);

	return showFilter;
};
